import { Box, ColorOptions, Icon, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { colors } from '../../util/colors'
import { isMobileWidth } from '../../util/util'

const StatisticContent = (data, isMobile) => {
  return data?.map((item: any) => {
    const Component = item.component
    return (
      <Box w={isMobile ? '100%' : 320} align={'center'} justify={'center'}>
        {!!Component && <Component width={60} height={48} />}
        {!!item.icon && <Icon id={item.icon} color={'WHITE' as ColorOptions} size={48} />}
        <Spacer size={isMobile ? 24 : 32} />
        <Text
          title={item.title}
          color={'WHITE' as ColorOptions}
          fontFamily={'jiotype-black'}
          textAlign={'center'}
          fontSize={isMobile ? 18 : 32}
        />
        <Spacer size={8} />
        <Text
          title={item.subTitle}
          color={'WHITE' as ColorOptions}
          fontFamily={'jiotype-medium'}
          fontSize={isMobile ? 14 : 18}
          opacity={0.7}
        />
      </Box>
    )
  })
}

export const Statistics = ({ data }: any) => {
  const viewPortWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewPortWidth)

  return (
    <Box
      flexDirection={isMobile ? 'column' : 'row'}
      gap={isMobile ? 64 : 120}
      justify={'center'}
      bg={colors.JIO_PRIMARY_ALPHA as ColorOptions}
      pt={88}
      pb={216}>
      {StatisticContent(data, isMobile)}
    </Box>
  )
}
